var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[_c('v-tab',[_vm._v("Обзор")]),_c('v-tab-item',[_c('report-page')],1),_c('v-tab-item',[_vm._v("Статистика2")]),_c('v-tab-item',[_vm._v("Статистика3")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }